<template>
  <div class="recommended-banner">
    <h2>{{recommended}}</h2>
  </div>
</template>

<script>
export default {
  name: 'RecommendedBanner',
  props: {
    recommended: {
      type: String,
      default: ''
    },
  },
}
</script>

<style lang="scss">

.recommended-banner {
  background-color: rgba($blue, 0.2);
  padding: 1rem;
  h2 {
    text-align: center;
    font-weight: 900;
    text-transform: uppercase;
    font-size: 22px;
    color: $blue;
    margin: 0;
  }
  @include breakpoint(large) {
    padding: 2em 1rem;
    h2 {
      font-size: 30px;
    }
  }
}

</style>